import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { useTranslation } from "react-i18next";
import {RMFlightWrapper} from "../../../types";

function CopyToClipboardButton() {
  const checkedFlights = useAppSelector(
    (state) => state.searchFlights.results.checkedFlights
  );
  const { t } = useTranslation();
  const [label, setLabel] = useState<string>("");

  const onCopy = () => {
    //@ts-ignore
    if (window.clipboardData) {
      selectElementContents(document.getElementById("clipboard-table"));
    } else {
      copyToClip(document.getElementById("clipboard-wrapper").innerHTML);
    }
    const oldLabel = label;
    setLabel(t("CLIPBOARD_COPIED"));
    const interval = setInterval(() => {
      setLabel(oldLabel);
      clearInterval(interval);
    }, 2000);
  };

  function selectElementContents(el) {
    el.style.display = "block";
    let range, sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
      document.execCommand("copy");
    }
    el.style.display = "none";
  }

  function copyToClip(str) {
    const augmentedStr = `<html lang="en"><body>${str}</body></html>`;
    function listener(e) {
      e.clipboardData.setData("text/html", augmentedStr);
      e.clipboardData.setData(
        "text/plain",
        augmentedStr
          .replaceAll("</td><td>", "\t")
          .replaceAll("</th><th>", "\t")
          .replaceAll("</tr><tr>", "\n")
          .replaceAll("<tbody>", "\n")
          .replaceAll(/(<([^>]+)>)/gi, "")
      );
      e.preventDefault();
    }
    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
  }

  useEffect(() => {
    let count = 0;
    for (const [key, value] of Object.entries(checkedFlights)) {
      if (key === "all") {
        count = -1;
        break;
      }
      if (value) {
        count = count + 1;
      }
    }
    if (count !== 0) {
      setLabel(t("CLIPBOARD_COPY"));
    } else {
      setLabel("");
    }
  }, [checkedFlights, t]);

  if (label !== "") {
    return (
      <div className="is-fab">
        <button className="button is-primary is-rounded" onClick={onCopy}>
          <span className="icon is-small">
            <FontAwesomeIcon icon={faClipboard} />
          </span>
          <span>{label}</span>
        </button>
        <div id="clipboard-wrapper">
          <table id="clipboard-table">
            <thead>
              <tr>
                <th>{t("HEADER_SORT_AIRLINE")}</th>
                <th>{t("FLIGHT")}</th>
                <th>{t("INPUT_LABEL_FROM")}</th>
                <th>{t("INPUT_LABEL_TO")}</th>
                <th>{t("DEPARTS")}</th>
                <th>{t("ARRIVES")}</th>
              </tr>
            </thead>
            {Object.values(checkedFlights).map((flight: RMFlightWrapper | boolean, i) => {
              if (flight && flight !== true) {
                return (
                  <tbody key={i}>
                    <tr key={i}>
                      <td>{flight.airline}</td>
                      <td>
                        {flight.operatedBy}
                        {flight.flightNo}
                      </td>
                      <td>{flight.depart}</td>
                      <td>
                        {flight.connxLeg1Arrival != null
                          ? flight.connxLeg1Arrival
                          : flight.arrival}
                      </td>
                      <td>{flight.departureTimeAsString}</td>
                      <td>
                        {flight.connxLeg1ArrivalTimeAsString !== null
                          ? flight.connxLeg1ArrivalTimeAsString
                          : flight.arrivalTimeAsString}
                      </td>
                    </tr>
                    {flight.connxLeg2OperatedBy !== null && (
                      <tr key={`${i}#2`}>
                        <td>{flight.connxLeg2Airline}</td>
                        <td>
                          {flight.connxLeg2OperatedBy}
                          {flight.connxLeg2FlightNo}
                        </td>
                        <td>{flight.connxLeg2Depart}</td>
                        <td>
                          {flight.connxLeg2Arrival !== null
                            ? flight.connxLeg2Arrival
                            : flight.arrival}
                        </td>
                        <td>{flight.connxLeg2DepartureTimeAsString}</td>
                        <td>
                          {flight.connxLeg2ArrivalTimeAsString !== null
                            ? flight.connxLeg2ArrivalTimeAsString
                            : flight.arrivalTimeAsString}
                        </td>
                      </tr>
                    )}
                    {flight.connxLeg3OperatedBy !== null && (
                      <tr key={`${i}#3`}>
                        <td>{flight.connxLeg3Airline}</td>
                        <td>
                          {flight.connxLeg3OperatedBy}
                          {flight.connxLeg3FlightNo}
                        </td>
                        <td>{flight.connxLeg3Depart}</td>
                        <td>
                          {flight.connxLeg3Arrival !== null
                            ? flight.connxLeg3Arrival
                            : flight.arrival}
                        </td>
                        <td>{flight.connxLeg3DepartureTimeAsString}</td>
                        <td>
                          {flight.connxLeg3ArrivalTimeAsString !== null
                            ? flight.connxLeg3ArrivalTimeAsString
                            : flight.arrivalTimeAsString}
                        </td>
                      </tr>
                    )}
                    {flight.connxLeg2OperatedBy !== null && (
                      <tr key={`${i}-sep`}>
                        <td colSpan={6} />
                      </tr>
                    )}
                  </tbody>
                );
              } else {
                return null;
              }
            })}
          </table>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default CopyToClipboardButton;
